module.exports = __webpack_public_path__ + "img/a3132abbb82a173a9c9875982e52829.a97cab1e.jpg";